module.exports = __webpack_public_path__ + "img/img01.5b17c18b.svg";